<template>
    <div class="bottom">
        <div class="bottom-content">
          <div class="link">友情链接</div>
          <div class="item">
            <el-row :gutter="20">
              <el-col :span="4"
                ><div class="grid-content bg-purple">
                  <a href="#">中国心理学会</a>
                </div></el-col
              >
              <el-col :span="6"
                ><div class="grid-content bg-purple">
                  <a href="#">华东师范大学</a>
                </div></el-col
              >
              <el-col :span="6"
                ><div class="grid-content bg-purple"></div
              ></el-col>
              <el-col :span="8"
                ><div class="grid-content bg-purple">
                  <img src="../../content/img/police.jpg" alt="" /> 沪公网安备
                  31010702006445号
                </div></el-col
              >
            </el-row>
          </div>
          <div class="item">
            <el-row :gutter="20">
              <el-col :span="4"
                ><div class="grid-content bg-purple">
                  <a href="#">上海市心理学会</a>
                </div></el-col
              >
              <el-col :span="6"
                ><div class="grid-content bg-purple">
                  <a href="#">上海华东师大科教仪器有限公司</a>
                </div></el-col
              >
              <el-col :span="6"
                ><div class="grid-content bg-purple">
                  沪ICP备06023012号-2
                </div></el-col
              >
              <el-col :span="8"
                ><div class="grid-content bg-purple">
                  技术支持 - 上海华东师大科教仪器有限公司
                </div></el-col
              >
            </el-row>
          </div>
        </div>
      </div>
</template>
<style lang="scss" scoped>
    .bottom {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  max-height: 148px;
  height: 15vh;
  background-color: #383838;
  z-index: -1;
  .bottom-content {
    margin: 0 auto;
    margin-top: 1vh;
    width: 78%;
    font-family: MicrosoftYaHei;
    font-size: 13px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #666;
    a {
      font-family: MicrosoftYaHei;
      font-size: 13px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      text-align: left;
      color: #666;
      text-decoration: none;
      z-index: 100;
    }
    a:hover {
      color: blue;
    }
    .link {
      font-family: MicrosoftYaHeiUI;
      font-size: 16px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: 0.64px;
      text-align: left;
      color: #888;
    }
    .item {
      margin-top: 1vh;
    }
  }
}
</style>